import { Avatar, Dropdown, MenuProps } from 'antd';
import clsx from 'clsx';
import CheckReadOutlineIcon from 'components/AppIcon/CheckReadOutlineIcon';
import MenuDotsOutlineIcon from 'components/AppIcon/MenuDotsOutlineIcon';
import TrashBinTrashOutlineIcon from 'components/AppIcon/TrashBinTrashOutlineIcon';
import { renderTag } from 'features/notification/constants';
import { TNotification } from 'features/notification/types';

type Props = {
  data: TNotification;
  viewMode?: 'panel' | 'list-page';
};

export const NotificationItem = ({ data, viewMode = 'list-page' }: Props) => {
  const isPanelViewMode = viewMode === 'panel';

  const items: MenuProps['items'] = [
    {
      key: 'read',
      label: (
        <div className="flex items-center gap-2 text-sm">
          <CheckReadOutlineIcon className="h-4 w-4 text-[#006eb3]" />
          Đã đọc
        </div>
      ),
    },
    {
      key: 'delete',
      label: (
        <div className="flex items-center gap-2 text-sm">
          <TrashBinTrashOutlineIcon className="h-4 w-4 text-[#006eb3]" />
          Xóa
        </div>
      ),
    },
  ];

  return (
    <div className="flex items-start justify-between gap-3">
      <div className="flex gap-4">
        <Avatar size={isPanelViewMode ? 36 : 48} className="shrink-0">
          CV
        </Avatar>

        <div>
          <p
            className={clsx(
              'line-clamp-2 text-ellipsis',
              data?.isRead ? 'font-normal' : 'font-semibold',
              isPanelViewMode ? 'text-sm' : 'text-base'
            )}
          >
            {data.title}
          </p>
          <p
            className={clsx(
              'mt-1.5 text-xs',
              data?.isRead ? 'text-black' : 'text-primary'
            )}
          >
            {data.date}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-end gap-2">
        {renderTag(data.type)}

        {!isPanelViewMode && (
          <Dropdown
            menu={{ items }}
            trigger={['click']}
            placement="bottomRight"
            align={{
              offset: [0, 8],
            }}
          >
            <MenuDotsOutlineIcon className="h-5 w-5 rotate-90 cursor-pointer text-[#bfbfbf]" />
          </Dropdown>
        )}
      </div>
    </div>
  );
};
